"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
var NavItem = function NavItem(_ref) {
  var className = _ref.className,
    data = _ref.data,
    liClassName = _ref.liClassName,
    divClassName = _ref.divClassName,
    linkClassName = _ref.linkClassName;
  return _react.default.createElement("ul", {
    className: "" + className
  }, data && Object.keys(data).map(function (item, index) {
    var keyValue = "nav-item-level-" + index;
    return _react.default.createElement("li", {
      className: liClassName + " " + liClassName + "--level-" + data[item].level,
      key: keyValue
    }, _react.default.createElement("div", {
      className: divClassName
    }, _react.default.createElement(_Anchor.default, {
      className: linkClassName,
      to: data[item].url,
      as: data[item].asPath,
      title: data[item].title
    }, data[item].title)));
  }));
};
NavItem.defaultProps = {
  divClassName: ''
};
var _default = NavItem;
exports.default = _default;
module.exports = exports["default"];